import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react'; // Make sure you have lucide-react installed: npm install lucide-react
import constant from '../../../constant'; // Adjust the path to your constant file
import ImsForm from '../../ui/imsForm';

const AddIms = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleCancel = () => {
        navigate('/purchases/ims'); // Adjust the route as needed
    };

    const handleSubmit = async (imsData) => {
        setLoading(true);
        setError(null);

        try {
            const token = localStorage.getItem('token');

            if (!token) {
                setError('No authentication token found');
                return;
            }

            const response = await fetch(`${constant.REACT_APP_API_URL}/purchase/ims`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(imsData),
            });

            const result = await response.json();

            if (response.ok) {
                navigate('/purchases/ims');
            } else {
                setError(result.message || 'Failed to add IMS data');
            }
        } catch (err) {
            setError('Error adding IMS data: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => {
        navigate(-1);
    };

    return (
        <div className="min-h-screen bg-gray-50 p-6">
            <div className="max-w-5xl mx-auto">
                {/* Header */}
                <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
                    <div className="flex items-center space-x-4">
                        <button onClick={handleBack} className="text-gray-500 hover:text-gray-700 transition-colors">
                            <ArrowLeft className="h-6 w-6" />
                        </button>
                        <h2 className="text-2xl font-bold text-gray-800">Add IMS Data</h2>
                    </div>
                </div>
                {loading && (
                    <div className="bg-blue-50 text-blue-700 p-4 rounded-lg mb-6">
                        Processing...
                    </div>
                )}
                {error && (
                    <div className="bg-red-50 text-red-700 p-4 rounded-lg mb-6">
                        {error}
                    </div>
                )}

                <ImsForm onSubmit={handleSubmit} onCancel={handleCancel} />
            </div>
        </div>
    );
};

export default AddIms;